module.exports = __webpack_public_path__ + "img/Main-logo.6813e37b.png";